import { useEffect } from 'react'

const SCRIPT_ID = 'tktries-ticketing-standalone'
const TKTRIES_HUB = 'https://tkt.coteries.com'

const TKTRIES_LANGS = ['en', 'fr', 'de']

export const toTktriesLang = lang => (TKTRIES_LANGS.includes(lang) ? lang : 'en')

export const useTktriesEmbedScript = ({
  apiKey,
  lang = 'en',
  theme = 'light',
  enabled = true,
}) => {
  useEffect(() => {
    if (!enabled) return
    if (!apiKey) return
    if (document.getElementById(SCRIPT_ID)) return
    const el = document.createElement('script')
    el.id = SCRIPT_ID
    el.src = `${TKTRIES_HUB}/ticketing-standalone.js?${new URLSearchParams({
      apiKey,
      lang,
      theme,
    }).toString()}`
    el.referrerPolicy = 'origin'
    document.head.appendChild(el)
  }, [apiKey, lang, theme, enabled])
}
